// extracted by mini-css-extract-plugin
export default {"container":"WaitingConfirmation_container__qAMF3","title":"WaitingConfirmation_title__tuC5F","loader":"WaitingConfirmation_loader__DCGSL"};